import { createRouter, createWebHistory } from "vue-router";
import { featureFlags } from "@/config/featureFlags";

// Orchestrator views
import Overvaagning from "@/views/orchestrator/overvaagning.vue";
import Processer from "@/views/orchestrator/Automationer/Processer.vue";
import Jobs from "@/views/orchestrator/Automationer/Jobs.vue";
import MakeNewTrigger from "@/views/orchestrator/Automationer/MakeNewTrigger.vue"

// Analytics views
import Business from "@/views/analytics/Business.vue";
import Operations from "@/views/analytics/Operations.vue";
import Settings from "@/views/analytics/Settings.vue";

// ETL views — only used when featureFlags.etl is on. The static imports stay
// here so the build doesn't have to dynamic-import; the routes themselves are
// conditionally registered below. If you want to strip the ETL chunks from a
// flag-off build entirely, switch these to defineAsyncComponent or lazy
// imports gated on the flag.
import ConnectionsView from "@/Modules/ETL/views/ConnectionsView.vue";
import PipelinesView from "@/Modules/ETL/views/PipelinesView.vue";
import PipelineBuilderView from "@/Modules/ETL/views/PipelineBuilderView.vue";
import DataView from "@/Modules/ETL/views/DataView.vue";

const orchestratorRoutes = [
  { path: "/Overvaagning", name: "overvaagning", component: Overvaagning },
  { path: "/Automationer/Processer", name: "processer", component: Processer },
  { path: "/Automationer/Jobs", name: "Jobs", component: Jobs },
  { path: "/Automationer/MakeNewTrigger", name: "MakeNewTrigger", component: MakeNewTrigger },
];

const analyticsRoutes = [
  { path: "/Analytics/Business", name: "Business", component: Business },
  { path: "/Analytics/Operations", name: "Operations", component: Operations },
  { path: "/Analytics/Settings", name: "Settings", component: Settings },
];

const etlRoutes = [
  { path: "/ETL", redirect: "/ETL/connections" },
  { path: "/ETL/connections", name: "ETLConnections", component: ConnectionsView },
  { path: "/ETL/connections/new", name: "ETLNewConnection", component: ConnectionsView },
  { path: "/ETL/pipelines", name: "ETLPipelines", component: PipelinesView },
  { path: "/ETL/pipelines/new", name: "ETLNewPipeline", component: PipelineBuilderView },
  { path: "/ETL/pipelines/:id/edit", name: "ETLEditPipeline", component: PipelineBuilderView },
  { path: "/ETL/data", name: "ETLData", component: DataView },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: "/", redirect: "/Overvaagning" },
    ...orchestratorRoutes,
    ...analyticsRoutes,
    ...(featureFlags.etl ? etlRoutes : []),
    // Catch-all: any unknown path (including /ETL/* when the flag is off)
    // redirects to the default landing route.
    { path: "/:pathMatch(.*)*", redirect: "/Overvaagning" },
  ],
});

export default router;
